import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import SearchClientProfileEntriesForm from "../../components/searching/search-form";
import NoEntriesMessage from "../../../../components/common/NoEntriesMessage/NoEntriesMessage";
import {
  setSearchFilters,
  getClientProfileEntries,
  setCurrentPage,
  getClientProfileEntriesCount,
  clearProfileDetailsEntries,
  setItemsPerPage,
} from "../../actions";
import {
  pageInfoSelector,
  selector,
  clientProfileEntriesLoading,
  noEntriesMessageClientProfileSelector,
  clientProfilePdfExportIsLoadingSelector,
} from "../../selectors";
import SearchClientProfileEntriesTable from "../../components/searching/search-form/table";

import "./clientProfile.css";
import Pagination from "../../../../components/Pagination/Pagination";
import { PageTitle } from "../../../../components/common";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";
import { trimFormData } from "../../../../utilities/filters";

const ClientProfilePage = () => {
  const clientProfileEntries = useSelector(selector);
  const isLoading = useSelector(clientProfileEntriesLoading);
  const isLoadingExport = useSelector(clientProfilePdfExportIsLoadingSelector);
  const noEntriesMessage = useSelector(noEntriesMessageClientProfileSelector);
  const { count, itemsPerPage, currentPage } = useSelector(pageInfoSelector);

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isOpenCollapse, setIsOpenCollapse] = useState(true);

  const toggleCollapse = () => setIsOpenCollapse(!isOpenCollapse);

  const dispatch = useDispatch();

  useEffect(() => {
    if (count > 0 && isSubmitted) {
      dispatch(getClientProfileEntries({ take: itemsPerPage }));
      setIsSubmitted(false);
    }
  }, [count]);

  useEffect(
    () => () => {
      dispatch(clearProfileDetailsEntries());
    },
    []
  );

  const handleSubmit = (data) => {
    if (!isOpenCollapse) {
      return;
    }
    const trimmedData = trimFormData(data);
    dispatch(setSearchFilters(trimmedData));
    dispatch(getClientProfileEntriesCount(trimmedData));
    setIsSubmitted(true);
    toggleCollapse();
  };

  const onPageChange = (_, page) => {
    dispatch(setCurrentPage(page + 1));
    const skip = page * itemsPerPage;
    dispatch(getClientProfileEntries({ take: itemsPerPage, skip }));
  };

  const onRowsPerPageChange = ({ target }) => {
    dispatch(setCurrentPage(1));
    dispatch(setItemsPerPage(Number(target.value)));
    dispatch(getClientProfileEntries({ take: Number(target.value), skip: 0 }));
  };

  return (
    <Container
      className="client-profile-entries-page-container col-12 p-0"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          document
            .getElementById("searchClientProfileEntriesSubmitButton")
            .click();
        }
      }}
    >
      <PageTitle title="client profile" />
      <FullscreenLoader loading={isLoading || isLoadingExport} />
      {clientProfileEntries.length ? null : (
        <div className="client-profile-page-background-logo" />
      )}

      <SearchClientProfileEntriesForm
        isOpenCollapse={isOpenCollapse}
        toggleCollapse={toggleCollapse}
        handleSubmit={handleSubmit}
        clientProfileEntries={clientProfileEntries}
      />

      {clientProfileEntries.length > 0 ? (
        <React.Fragment>
          <SearchClientProfileEntriesTable
            clientProfileEntries={clientProfileEntries}
          />
          {count ? (
            <Row className="pagination-row mt-5 mb-5">
              <Pagination
                count={count}
                onPageChange={onPageChange}
                onRowsPerPageChange={onRowsPerPageChange}
                rowsPerPage={itemsPerPage}
                page={currentPage - 1}
              />
            </Row>
          ) : null}
        </React.Fragment>
      ) : (
        <NoEntriesMessage payload={noEntriesMessage} />
      )}
    </Container>
  );
};

export default ClientProfilePage;



// WEBPACK FOOTER //
// ./src/features/client-profile/pages/client-profile-page/clientProfile.jsx